import { render, staticRenderFns } from "./WindowsPasswordReset.vue?vue&type=template&id=298e7492"
import script from "./WindowsPasswordReset.vue?vue&type=script&lang=js"
export * from "./WindowsPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports